// ===========================================================================
// Module A — Post-Discharge Care Coordination
// Constantes y enums del módulo.
// ===========================================================================

/** Locations disponibles en los dumps de DataDashCareManager. */
export const LOCATIONS = [
  { key: "fort_myers", label: "Fort Myers" },
  { key: "fort_pierce", label: "Fort Pierce" },
  { key: "hialeah", label: "Hialeah" },
  { key: "immokalee", label: "Immokalee" },
  { key: "lake_worth", label: "Lake Worth" },
  { key: "lehigh_acres", label: "Lehigh Acres" },
  { key: "lehigh_acres_5705", label: "Lehigh Acres 5705" },
  { key: "naples", label: "Naples" },
  { key: "naples_5262", label: "Naples 5262" },
  { key: "port_st_lucie", label: "Port St. Lucie" },
];

export const DEFAULT_LOCATION = "fort_myers";

/** Estados de follow-up post-alta (espejo de census.TAB_TRANSITION_FOLLOWUP.VAR_STATUS). */
export const FOLLOW_UP_STATUS = {
  PENDING: "PENDING",
  OUTREACH: "OUTREACH",
  SCHEDULED: "SCHEDULED",
  COMPLETED: "COMPLETED",
  NO_SHOW: "NO_SHOW",
};

/** Presentación de cada estado de follow-up (label + tono semántico). */
export const FOLLOW_UP_META = {
  PENDING: { label: "Pending outreach", tone: "crit" },
  OUTREACH: { label: "Outreach in progress", tone: "warn" },
  SCHEDULED: { label: "Appointment scheduled", tone: "info" },
  COMPLETED: { label: "Visit completed", tone: "ok" },
  NO_SHOW: { label: "No-show", tone: "crit" },
};

/** Estado de la ventana de facturación TCM (CPT 99495 / 99496). */
export const TCM_WINDOW = {
  WINDOW_7D: "WINDOW_7D", // dentro de los 7 días — 99496 (alta complejidad) aún elegible
  WINDOW_14D: "WINDOW_14D", // días 8-14 — solo 99495 (complejidad moderada)
  EXPIRED: "EXPIRED", // fuera de ventana TCM
};

export const TCM_WINDOW_META = {
  WINDOW_7D: { label: "TCM 7-day window open (99496)", tone: "ok" },
  WINDOW_14D: { label: "TCM 14-day window open (99495)", tone: "warn" },
  EXPIRED: { label: "TCM window expired", tone: "crit" },
};

/** Prioridad derivada del LACE score. */
export const PRIORITY_META = {
  HIGH: { label: "High", tone: "crit" },
  MEDIUM: { label: "Medium", tone: "warn" },
  LOW: { label: "Low", tone: "ok" },
};

/** Canales y resultados de contacto para el log de outreach local. */
export const CONTACT_CHANNELS = ["Call", "SMS", "Email"];
export const CONTACT_OUTCOMES = [
  "Reached — appointment discussed",
  "Voicemail left",
  "No answer",
  "Wrong number",
  "Declined follow-up",
];
